module.exports = __webpack_public_path__ + "assets/img/copyright-one.e41fe9b5.png";